import React from 'react';
import { Col, Row } from 'antd';
import styles from './DashboardView.module.css';
import DataManagementPanelContainer from '../DataManagementPanel/DataManagementPanelContainer';
import GeneralSettingsContainer from '../GeneralSettings/GeneralSettingsContainer';
import FogOfWarSettingsContainer from '../FogOfWarSettings/FogOfWarSettingsContainer';

const SettingsView: React.FC = () => {
  return (
    <div className={styles.grid}>
      <div style={{ gridColumn: '1 / -1', padding: '1rem' }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12} lg={8}><GeneralSettingsContainer /></Col>
          <Col xs={24} md={12} lg={8}><FogOfWarSettingsContainer /></Col>
          <Col xs={24} md={12} lg={8}><DataManagementPanelContainer /></Col>
        </Row>
      </div>
    </div>
  );
};

export default SettingsView;